import { useEffect, useRef, useState } from "react";
import { api, GEAR_CATEGORIES } from "../lib/api";
import { SkeletonRows } from "../components/Skeleton";

const STUDIO_TABS = [
  { key: "balboa", label: "Balboa" },
  { key: "bungalow", label: "The Bungalow" },
];

export default function Gear() {
  const [active, setActive] = useState("balboa");
  const [items, setItems] = useState({ balboa: [], bungalow: [] });
  const [loading, setLoading] = useState(true);
  const switchRef = useRef(null);

  useEffect(() => {
    Promise.all([api.get("/gear?studio=balboa"), api.get("/gear?studio=bungalow")])
      .then(([a, b]) => setItems({ balboa: a.data?.items || [], bungalow: b.data?.items || [] }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const switchStudio = (key) => {
    if (key === active) return;
    setActive(key);
    switchRef.current?.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  const list = items[active];

  return (
    <div data-testid="gear-page">
      <div className="wrap page-head">
        <p className="label" style={{ color: "var(--orange)" }}>Gear</p>
        <h1 className="disp" style={{ marginTop: 12 }}>
          <span className="misreg" data-text="What's Here">What's Here</span>
        </h1>
        <p className="measure" style={{ marginTop: 20 }}>
          Everything below lives at the studio and is included in the day rate. No rental add-ons, no surprise
          line items.
        </p>
      </div>

      <div className="wrap" ref={switchRef} style={{ scrollMarginTop: 80 }}>
        <div className="studio-switch" data-testid="gear-switch">
          {STUDIO_TABS.map((t) => (
            <button
              key={t.key}
              className={`tab studio-tab${active === t.key ? " active" : ""}`}
              onClick={() => switchStudio(t.key)}
              data-testid={`gear-tab-${t.key}`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="wrap studio-panel" style={{ paddingBottom: 40 }} data-testid={`gear-panel-${active}`}>
        {GEAR_CATEGORIES.map((cat) => {
          const catItems = list.filter((i) => i.category === cat);
          return (
            <div
              className="gear-cat"
              key={cat}
              data-testid={`gear-cat-${active}-${cat.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <h2 className="disp" style={{ fontSize: "clamp(22px,3vw,32px)" }}>{cat}</h2>
              <div className="misreg-rule" style={{ marginTop: 10 }} />
              {loading ? (
                <div style={{ marginTop: 20 }}>
                  <SkeletonRows rows={4} h={40} testid={`gear-skeleton-${cat.toLowerCase().replace(/[^a-z]+/g, "-")}`} />
                </div>
              ) : catItems.length ? (
                <div className="gear-items">
                  {catItems.map((g) => (
                    <div className="gear-item" key={g.id}>
                      <span>{g.name}</span>
                      <span>{g.model}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty" style={{ marginTop: 20 }}>— nothing here yet —</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
